import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { UsersIcon, SearchIcon, ShieldCheckIcon, TrendingUpIcon } from 'lucide-react';
const services = [{
  icon: UsersIcon,
  title: 'Gestión integral',
  description: 'Desde la definición del perfil hasta la incorporación del candidato.',
  color: 'bg-emerald-50',
  iconColor: 'text-emerald-600',
  iconBg: 'bg-emerald-100'
}, {
  icon: SearchIcon,
  title: 'Cobertura nacional y selección de múltiples posiciones',
  description: 'Operativas, mandos medios y gerenciales.',
  color: 'bg-purple-50',
  iconColor: 'text-purple-700',
  iconBg: 'bg-purple-100'
}, {
  icon: ShieldCheckIcon,
  title: 'Selección personalizada y confidencial',
  description: 'Garantizamos procesos adaptados a la cultura organizacional y a los objetivos estratégicos de cada empresa.',
  color: 'bg-pink-50',
  iconColor: 'text-pink-600',
  iconBg: 'bg-pink-100'
}, {
  icon: TrendingUpIcon,
  title: 'Acompañamiento en la incorporación',
  description: 'Proveemos una integración cuidada, fluida y sostenible en el tiempo.',
  color: 'bg-blue-50',
  iconColor: 'text-blue-600',
  iconBg: 'bg-blue-100'
}];
export function Services() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="servicios" ref={ref} className="py-32 px-6 bg-white scroll-mt-20" data-id="element-170">
      <div className="max-w-7xl mx-auto" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-172">
          <h2 className="text-4xl md:text-6xl font-bold text-slate-900 mb-4" style={{
          fontFamily: 'Poppins, sans-serif',
          letterSpacing: '-0.02em'
        }} data-id="element-173">
            Nuestros Servicios
          </h2>
          <p className="text-xl text-purple-700 font-semibold mb-6" data-id="element-174">
            Donde el talento encuentra su lugar
          </p>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto leading-relaxed" data-id="element-175">
            Sabemos que encontrar a la persona indicada no siempre es fácil. Por
            eso, en Enlaces Consultora acompañamos a las empresas en crecimiento
            para construir equipos sólidos, con procesos ágiles, confiables y
            comprometidos.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-176">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className={`p-8 ${service.color} rounded-2xl border border-slate-100 hover:shadow-lg transition-all duration-300`} data-id="element-177">
              <div className={`w-14 h-14 ${service.iconBg} rounded-xl flex items-center justify-center mb-4`} data-id="element-178">
                <service.icon className={`w-7 h-7 ${service.iconColor}`} data-id="element-179" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" style={{
            fontFamily: 'Poppins, sans-serif'
          }} data-id="element-180">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-181">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}